const getCOSQSliderWidth = ({ isMobile, windowWidth, fixedWidth }) => {
  return isMobile ? windowWidth - 100 : fixedWidth ? fixedWidth : 400;
};

export default getCOSQSliderWidth;
